import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AgentBreadcrumbComponent } from '../components/agent-breadcrumb/agent-breadcrumb.component';
import { DisclaimerComponent } from '../components/disclaimer/disclaimer.component';
import { FeedbackComponent } from '../components/feedback/feedback.component';
import { ToastService } from '../service/toast/toast.service';
import { AgentFiveHomeComponent } from './agent-five-home/agent-five-home.component';
import { AgentFiveTabComponent } from './agent-five-tab/agent-five-tab.component';
import { SurveyKey } from 'app/models/feedback-question';
import { AgentId } from 'app/models/agents';
import { Tab } from 'app/models/tab';
import { TabListComponent } from '../components/tab-list/tab-list.component';

@Component({
  selector: 'app-agent-five',
  standalone: true,
  imports: [
    CommonModule,
    AgentBreadcrumbComponent,
    AgentFiveHomeComponent,
    AgentFiveTabComponent,
    DisclaimerComponent,
    FeedbackComponent,
    TabListComponent,
  ],
  templateUrl: './agent-five.component.html',
  styleUrl: './agent-five.component.scss',
})
export class AgentFiveComponent implements OnInit {
  tabs: Tab[] = [
    { tabName: 'Home', tabNumberOrder: 1, isActive: true },
    {
      tabName: 'Financial Statement Review',
      tabNumberOrder: 2,
      isActive: false,
    },
    {
      tabName: 'Financial Statement to Computation comparison',
      tabNumberOrder: 3,
      isActive: false,
    },
    {
      tabName: 'Current Year to Prior Year Computation comparison',
      tabNumberOrder: 4,
      isActive: false,
    },
  ];

  currentTab: Tab = {
    tabName: 'Home',
    tabNumberOrder: 1,
    isActive: true,
  };

  get isAtHomeTab(): boolean {
    return this.currentTab.tabNumberOrder === 1;
  }

  feedbackSurveyKey?: SurveyKey;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.toastService.clearToastWithTag(true);
  }

  toggleTab(tab: Tab) {
    this.toastService.clearToastWithTag(true);

    this.tabs.forEach((tb: Tab) =>
      tb.tabNumberOrder === tab.tabNumberOrder
        ? (tb.isActive = true)
        : (tb.isActive = false)
    );
    this.currentTab = tab;

    if (this.isAtHomeTab) {
      this.feedbackSurveyKey = undefined;
    }
  }

  toggleTabOnNumber($event: number) {
    const tab: Tab | undefined = this.tabs.find(
      (tb: Tab) => tb.tabNumberOrder === $event
    );

    if (tab) {
      this.toggleTab(tab);
    }
  }

  assignProjectIdToFeedback(projectId: string) {
    this.feedbackSurveyKey = projectId
      ? {
          projectId,
          agentId: AgentId.ANOMALY_DETECTION,
        }
      : undefined;
  }
}
